import { useEffect } from 'react';
import { RefreshCw } from 'lucide-react';
import { Button, Hinweis } from '@dxl/ui';

/** Skript eines älteren Stands nicht mehr vorhanden (nach einer Auslieferung) */
const istLadefehler = (e: unknown) => /dynamically imported module|Importing a module script failed|Failed to fetch|error loading dynamically/i.test(String((e as Error)?.message ?? e));

/** Fehler beim Anzeigen einer Seite: bei veralteten Skripten einmal automatisch neu laden, sonst Hinweis mit „Neu laden“ */
export function SeitenFehler({ error }: { error: unknown }) {
  const laden = istLadefehler(error);
  useEffect(() => {
    if (!laden) return;
    try {
      const zuletzt = Number(sessionStorage.getItem('dxl-neu-geladen') ?? 0);
      if (Date.now() - zuletzt < 30_000) return;
      sessionStorage.setItem('dxl-neu-geladen', String(Date.now()));
    } catch {
      /* ohne Speicher trotzdem neu laden */
    }
    window.location.reload();
  }, [laden]);
  return (
    <div className="seitenfehler">
      <Hinweis art={laden ? 'info' : 'fehler'}>
        {laden
          ? 'Die Commerce Plattform wurde gerade aktualisiert. Bitte laden Sie die Seite neu.'
          : 'Diese Seite konnte nicht angezeigt werden. Bitte laden Sie sie neu – besteht der Fehler weiter, melden Sie sich bei DXL.'}
      </Hinweis>
      <Button onClick={() => window.location.reload()}><RefreshCw aria-hidden /> Neu laden</Button>
    </div>
  );
}
